import { invoke as tauri_invoke } from '@tauri-apps/api/core';
export { tauri_invoke };
import type * as TauriAPI from '@tauri-apps/api';

declare global {
    interface Window {
        __TAURI__?: typeof TauriAPI;
        tauri_set_api_url: (url: string) => void;
        tauri_get_api_url: () => Promise<string>;
    }
}

export type TauriMonitor = {
    name?: string;
    size: {
        width: number;
        height: number;
    };
    position: any;
    work_area: {
        position: any;
        size: {
            width: number;
            height: number;
        };
    };
    scale_factor: number;
}

export function is_tauri(): boolean {
    if (window.__TAURI__) {
        return true;
    } else {
        return false;
    }
}

export function tauri_monitor(): Promise<TauriMonitor> {
    return tauri_invoke("current_monitor");
}

export function tauri_start_fullscreen() {
    tauri_invoke("start_fullscreen");
}

export function tauri_exit_fullscreen() {
    tauri_invoke("exit_fullscreen");
}

export function tauri_maximize_window() {
    tauri_invoke("maximize_window");
}

export function tauri_is_fullscreen(): Promise<boolean> {
    return tauri_invoke("is_fullscreen");
}

export function tauri_proxy_http(req: ArrayBuffer): Promise<ArrayBuffer> {
    return tauri_invoke("proxy_http", req);
}

export function tauri_system_os(): Promise<"macos" | "windows" | "linux" | "ios" | "android"> {
    return tauri_invoke("system_os");
}

export function tauri_set_api_url(url: string) {
    return tauri_invoke("set_api_url", { url });
}

export function tauri_get_api_url(): Promise<string> {
    return tauri_invoke("get_api_url");
}

export function tauri_persist_cookies(): Promise<void> {
    return tauri_invoke("persist_cookies");
}

export function tauri_download_and_open(path: string): Promise<void> {
    return tauri_invoke("download_and_open", { path });
}

// Attach tauri_set_api_url to the window object, so we can use it in the browser devtools console
window.tauri_set_api_url = tauri_set_api_url;
window.tauri_get_api_url = tauri_get_api_url;

// Logging
import { warn, debug, trace, info, error } from '@tauri-apps/plugin-log';

type Fn = 'log' | 'debug' | 'info' | 'warn' | 'error';

function forwardConsole(fnName: Fn, logger: (msg: string) => Promise<void>) {
    const original = console[fnName];
    console[fnName] = (...args: any[]) => {
        // Keep normal browser behavior:
        original(...args);
        // Mirror to Rust logs via the plugin:
        logger(args.map(a => (typeof a === 'string' ? a : JSON.stringify(a))).join(' '));
    };
}

if (is_tauri()) {
    forwardConsole('log', debug);
    forwardConsole('debug', debug);
    forwardConsole('info', info);
    forwardConsole('warn', warn);
    forwardConsole('error', error);
}